import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }
const _hoisted_2 = ["href", "download"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = {
  key: 1,
  class: "grid gap-3"
}
const _hoisted_7 = {
  class: "grid gap-3 text-red-500",
  style: {"grid-template-columns":"1fr 2fr"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    title: "Импорт норм себестоимости",
    "confirm-button-text": "Импортировать",
    loading: _ctx.state.is_loading || _ctx.check_state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.submitExcel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Тип перевозки",
        value: _ctx.state.invoiceType,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.invoiceType) = $event)),
        searchable: false,
        disabled: _ctx.state.is_loading || _ctx.check_state.is_loading,
        options: _ctx.INVOICE_TYPES,
        class: "mb-2",
        onChange: _ctx.onInvoiceTypeChange
      }, null, 8, ["value", "disabled", "options", "onChange"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_file_reader, {
          class: "flex-1",
          value: _ctx.state.file,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.file) = $event)),
          placeholder: "Выберите файл",
          accept: ".xlsx",
          disabled: _ctx.state.is_loading || _ctx.check_state.is_loading,
          "is-invalid": _ctx.state_form$.file.$error,
          "validation-errors": _ctx.state_form$.file.$errors,
          onChange: _ctx.onFileChange
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors", "onChange"]),
        _createElementVNode("a", {
          class: "block",
          href: _ctx.getTemplateLink,
          download: _ctx.getTemplateName
        }, [
          _createVNode(_component_the_button, {
            hint: "Скачать шаблон импорта",
            class: "primary small"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ], 8, _hoisted_2)
      ]),
      (_ctx.state.invoiceType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.check_state.is_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_Loader, { class: "primary" })
                ]))
              : _createCommentVNode("", true),
            (_ctx.check_state.warnings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.check_state.warnings, (warning) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", null, _toDisplayString(warning.fromCityName) + " - " + _toDisplayString(warning.toCityName), 1),
                      _createElementVNode("div", null, _toDisplayString(warning.reason), 1)
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}